import * as userService from 'services/user';
import { SectionTitle, useCompanyFormState } from '../common';
import { CompanyCategoriesField } from '../fields';
import AccountTreeTwoToneIcon from '@material-ui/icons/AccountTreeTwoTone';
import { green } from '@material-ui/core/colors';
import { Divider, Grid, Tooltip } from '@material-ui/core';
import { useFormContext, useWatch } from 'react-hook-form';
import { CompanyServiceField } from '../fields';
import { useRecentGetter } from '@lib/common';
import { useSubject } from '@lib/common/hooks/use-subject';
import { useSubscription } from '@lib/common/hooks/use-subscription';
import { useEffect, useRef } from 'react';
import { debounceTime, filter, pairwise, map, startWith } from 'rxjs/operators';
import { useInsightActions } from '../service-insights';
import { CompanyMasters } from '@api/masters';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import LockClosedIcon from '@material-ui/icons/Lock';
import Fab from '@material-ui/core/Fab';
import styled from 'styled-components';
import { useState } from 'react';
import { VerifiedDetails } from './section-utils';
import { getCompanyServices } from '@pages/company/utils';

export const SectionServices = () => {
  const { control } = useFormContext();

  /**
   * Setup events for the insighter.
   */
  //const { showServiceInsight } = useInsightActions();
  const serviceObserver = useWatch({ control, name: 'clientServices', defaultValue: [] });
  const form = useFormContext();
  const { edit, company } = useCompanyFormState();
  const { user } = userService.useUser();
  const [isLock, setLock] = useState<boolean>(
    (company &&
      company.verified_sections &&
      company.verified_sections.services_section &&
      company.verified_sections.services_section.verified) ||
      edit
  );
  const watchOnVerifiedSections = form.watch('verified_sections');
  const verifiedBy =
    watchOnVerifiedSections &&
    watchOnVerifiedSections.services_section &&
    watchOnVerifiedSections.services_section.verified_by;
  const verifiedAt =
    watchOnVerifiedSections &&
    watchOnVerifiedSections.services_section &&
    watchOnVerifiedSections.services_section.verified_at + ' IST';
  const service$ = useSubject<CompanyMasters.Service[]>();
  //const state = useRecentGetter({ showServiceInsight });
  //useEffect(() => service$.next(serviceObserver), [serviceObserver]);
  // useSubscription(() =>
  //   service$
  //     .pipe(
  //       startWith([] as CompanyMasters.Service[]),
  //       pairwise(),
  //       filter(([prev, next]) => next.length - prev.length === 1),
  //       map(([, next]) => next[next.length - 1])
  //     )
  //     .subscribe(srv => state().showServiceInsight({ service: srv }))
  // );
const processedIdsRef = useRef<Set<number>>(new Set());
useEffect(() => {
  if (!serviceObserver?.length) return;

  // Find services that:
  // 1. Don't have hierarchy yet
  // 2. Haven’t already been processed
  const newServices = serviceObserver.filter(
    s =>
      s.hierarchy_level == null &&
      s.ultimate_parent == null &&
      !processedIdsRef.current.has(s.id)
  );

  if (!newServices.length) return;

  const serviceIdsParam = newServices.map(s => s.id).join(',');

  const sub = getCompanyServices(serviceIdsParam, newServices)
    .subscribe((enriched) => {

      // Mark these IDs as processed
      enriched.forEach(s => processedIdsRef.current.add(s.id));

      // Merge only updated services
      const updated = serviceObserver.map(existing => {
        const found = enriched.find(e => e.id === existing.id);
        return found ? { ...existing, ...found } : existing;
      });

      form.setValue('clientServices', updated, {
        shouldDirty: true,
      });
    });

  return () => sub.unsubscribe();
}, [serviceObserver]);

  return (
    <>
      <Grid container spacing={2} justify="space-between">
        <Grid item>
          <SectionTitle
            id="company-services"
            title="Company Services"
            subTitle="Information about Company Services"
            icon={sectionIcon}
          />
        </Grid>
        <Grid item style={{ paddingBottom: '10px' }}>
          <Tooltip
            title={
              isLock ? (
                <>
                  {`Verified by ${verifiedBy}`}
                  <br />
                  {`Verified at ${verifiedAt}`}
                </>
              ) : (
                'Click to Lock the Section'
              )
            }>
            {isLock ? (
              <StyledFab
                color="primary"
                style={{ backgroundColor: 'green' }}
                aria-label="add"
                size="small"
                onClick={() => {
                  setLock(false);
                  form.setValue('verified_sections', {
                    ...form.watch('verified_sections'),
                    services_section: { verified: false, verified_by: null, verified_at: null,isLockApplied: false },
                  });
                }}>
                <LockClosedIcon />
              </StyledFab>
            ) : (
              <StyledFab
                color="primary"
                aria-label="add"
                style={{ backgroundColor: 'red' }}
                size="small"
                onClick={() => {
                  setLock(true);
                  form.setValue('verified_sections', {
                    ...form.watch('verified_sections'),
                    services_section: {
                      verified: true,
                      verified_by: user.vtr_id,
                      verified_at: new Date().toLocaleString('en-US', { timeZone: 'IST' }),
                      isLockApplied: true,
                    },
                  });
                  // company.verified_sections.services_section.verified_by = user.vtr_id;
                  // company.verified_sections.services_section.verified = true;
                }}>
                <LockOpenIcon />
              </StyledFab>
            )}
          </Tooltip>
          {isLock && <VerifiedDetails verifiedBy={verifiedBy} verifiedAt={verifiedAt} />}
        </Grid>
      </Grid>

      <Divider />
      <br />
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <CompanyServiceField
            control={control}
            name="clientServices"
           // similarClick={service => showServiceInsight({ service })}
            isLock={isLock}
            edit={edit}
          />
        </Grid>
        {/* <Grid item xs={6}>
          <CompanyCategoriesField control={control} name="categories" isLock={isLock} edit={edit} />
        </Grid> */}
      </Grid>
    </>
  );
};

const sectionIcon = <AccountTreeTwoToneIcon fontSize="large" style={{ color: green[600] }} />;

const StyledFab = styled(Fab)`
  &.MuiFab-sizeSmall {
    width: 40px;
    // height: 30px;
  }
  & .MuiSvgIcon-root {
    font-size: 1.4rem;
  }
`;
